import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from '../../not-found/not-found.component';
import { ContactsComponent } from './contacts/contacts.component';
import { ContactOverviewComponent } from './contacts/contact-overview/contact-overview.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { OrganizationOverviewComponent } from './organizations/organization-overview/organization-overview.component';
import { OrganizationSalesOrderOverviewComponent } from './organizations/organization-sales-order-overview/organization-sales-order-overview.component';
import { GoodsComponent } from './goods/goods.component';
import { InventoryItemOverviewComponent } from './goods/inventory-item-overview/inventory-item-overview.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoiceDetailComponent } from './sales-orders/invoice-detail/invoice-detail.component';
import { SalesOrdersComponent } from './sales-orders/sales-orders.component';
import { SalesOrderOverviewComponent } from './sales-orders/sales-order-overview/sales-order-overview.component';
import { ShipmentsComponent } from './shipments/shipments.component';
import { ShipmentOverviewComponent } from './shipments/shipment-overview/shipment-overview.component';

// Exported for route-registration tests (crm-routing.module.spec.ts).  Runtime
// behavior is unchanged - RouterModule.forChild(routes) below still owns wiring.
export const routes: Routes = [
  {
    path: 'contacts',
    component: ContactsComponent,
  },
  {
    path: 'contacts/:id',
    component: ContactOverviewComponent,
  },
  {
    path: 'organizations',
    component: OrganizationsComponent,
  },
  {
    path: 'organizations/:organizationId/sales-orders/:salesOrderId',
    component: OrganizationSalesOrderOverviewComponent,
  },
  {
    path: 'organizations/:id',
    component: OrganizationOverviewComponent,
  },
  {
    path: 'goods',
    component: GoodsComponent,
  },
  {
    path: 'sales-orders',
    component: SalesOrdersComponent,
  },
  {
    path: 'sales-orders/:salesOrderId/invoices/:invoiceId',
    component: InvoiceDetailComponent,
  },
  {
    path: 'sales-orders/:salesOrderId',
    component: SalesOrderOverviewComponent,
  },
  {
    path: 'goods/:id',
    component: InventoryItemOverviewComponent,
  },
  {
    path: 'invoices',
    component: InvoicesComponent,
  },
  {
    path: 'shipments',
    component: ShipmentsComponent,
  },
  {
    path: 'shipments/:shipmentId',
    component: ShipmentOverviewComponent,
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CrmRoutingModule {}
